// tslint:disable: max-line-length
import React, { useEffect, useState } from 'react';
import Avatar from 'lqa-ui/lib/Components/Avatar';
import { getItem } from '../../utils/localStorage';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import ReplyIcon from '../commons/icons/reply_icon';
import { actionPlansSeries } from './../../requests/actionPlan';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { showErrorMessage } from '../../helpers/showMessage';
import { getUserProfile } from '../../components/EditSelfAssessment/apiCaller';
import { isUnauthorized } from '../../utils/common';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import {
  ContentArea,
  DottedBorder,
  DottedBorderText,
  ReplayCardContainer,
  ArrowIconContainer,
  CardContainer,
  MessageMainContainer,
  CardInfo,
  CardMessageTitle,
  MessageSenderContainer,
  ButtonContainer,
} from './ActionPlansSeries.styled';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { Body6, Headline6 } from './../../app/common/typography';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { ISeriesData } from '../../app/@types/actionPlan';
import { ActionPlanStatus } from '../../enums/ActionPlanStatus';

const ActionPlansSeries = () => {
  const navigate = useNavigate();
  let isShowIcon = false;
  let dottedLineShowed = true;
  let isWhite = true;

  const { t } = useTranslation();
  const params = useParams();
  const [seriesData, setSeriesData] = useState<any>(undefined);
  const [sortedSeriesData, setSortedSeriesData] = useState<ISeriesData[]>([]);
  const [FifthLevel, setFifthLevel] = useState(true);
  useEffect(() => {
    localStorage.setItem('action', 'series');
    if (params.assessmentId && params.evnt && params.parentId && params.id) {
      actionPlansSeries(
        params.assessmentId,
        params.evnt === 'sent'
          ? parseInt(params.parentId ? params.parentId : '-1')
          : parseInt(params.id ? params.id : '-1')
      )
        .then((response) => {
          if (!response.length) {
            showErrorMessage('Could not find Action Plan Series');
            navigate(-1);
          } else {
            setSeriesData(response);
            setSortedSeriesData(calculateLevel(response));
            if (response.some((o) => o.lvl === 5)) {
              setFifthLevel(false);
            }
          }
        })
        .catch((err) => {
          showErrorMessage(
            'Could not find Action Plan Series',
            !isUnauthorized(err)
          );
        });
    }
  }, []);
  const userData = getItem('user');
  const isViewer = userData && userData.user && userData.user.isViewer;

  const handleCreateLinkedActionPlan = () => {
    const alreadyAssignedUsers = seriesData.map((o) => o.assignedId);
    const seriesOwner = seriesData.filter((o) => o.parentId === null)[0]
      .ownerId;
    alreadyAssignedUsers.push(seriesOwner);
    const actionPlanData = seriesData.find(
      (o) =>
        o.assigned.userFirstName === userData.user.userFirstName &&
        o.assigned.userLastName === userData.user.userLastName
    );
    navigate('/createActionPlan', {
      state: { actionPlanData, alreadyAssignedUsers },
    });
  };

  const handleCard = (data) => {
    navigate(`/editActionPlan/from-series/${params.evnt}/${data.id}`);
  };

  const UserAvatar = ({ userData, isShowIcon }) => {
    const [image, setImage] = useState(null);
    const fetchUserProfile = (userId) => {
      getUserProfile(userId).then((data) => {
        if (data && data[0] && data[0].url) {
          setImage(data[0].url);
        }
      });
    };

    const getImage = async () => {
      if (userData.assigned) {
        if (!isShowIcon) {
          if (userData.ownerId) {
            fetchUserProfile(userData.ownerId);
          }
        } else {
          fetchUserProfile(userData.assignedId);
        }
      } else {
        setImage(null);
      }
    };

    useEffect(() => {
      getImage();
    }, []);

    return (
      <Avatar
        name={
          userData.assigned
            ? !isShowIcon
              ? `${userData.owner.userFirstName
                  .split(' ')
                  .join('')} ${userData.owner.userLastName.split(' ').join('')}`
              : `${userData.assigned.userFirstName
                  .split(' ')
                  .join(
                    ''
                  )} ${userData.assigned.userLastName.split(' ').join('')}`
            : 'Multiple'
        }
        url={image}
        size={65}
        style={{ background: '#4fada6' }}
      />
    );
  };

  const calculateLevel = (data: ISeriesData[]): ISeriesData[] => {
    const itemMap: Record<number, ISeriesData> = {};
    const result: ISeriesData[] = [];
    data.forEach((item) => {
      itemMap[item.id] = { ...item, level: 0 };
    });
    const assignLevel = (item: ISeriesData, level: number) => {
      item.level = level;
      result.push(item);
      data
        .filter((child) => child.parentId === item.id)
        .forEach((child) => {
          let newLevel = level + 1;
          //  reset the level once auth user series started
          if (item.assignedId === userData.user.id) {
            newLevel = 0;
          }
          assignLevel(child, newLevel);
        });
    };
    data.forEach((item) => {
      if (item.parentId === null) {
        assignLevel(item, 0);
      }
    });
    return result;
  };
  function getStatusCardClass (actionPlan) {
    const currentDate = moment();
    const deadlineDate = moment(actionPlan.deadline);

    if (actionPlan.status === ActionPlanStatus.complete) {
      return 'replyBorderCompleted';
    }

    if (
      deadlineDate.isBefore(currentDate.subtract(1, 'days')) ||
      actionPlan.status === ActionPlanStatus.rejected
    ) {
      return 'replyBorderRed';
    }

    if (
      (deadlineDate.isSameOrAfter(currentDate.subtract(1, 'days')) &&
        actionPlan.status === ActionPlanStatus.open) ||
      actionPlan.status === ActionPlanStatus.complete
    ) {
      return 'replyBorderGreen';
    }

    if (actionPlan.status === ActionPlanStatus.awaitingApproval) {
      return 'replyBorderYellow';
    }

    return '';
  }

  return (
    <>
      <HeaderContainer>
        <AppHeader title={t('COMMON.ACTION_PLAN.SERIES_TITLE')} />
      </HeaderContainer>
      {!seriesData ? (
        <LoadingContent layout="flex" />
      ) : (
        <ContentArea>
          <div>
            {sortedSeriesData &&
              sortedSeriesData.map((series, i) => {
                isWhite = false;
                if (
                  (series.assigned.userFirstName ===
                    userData.user.userFirstName &&
                    series.assigned.userLastName ===
                      userData.user.userLastName) ||
                  (series.owner.userFirstName === userData.user.userFirstName &&
                    series.owner.userLastName === userData.user.userLastName)
                ) {
                  isWhite = true;
                }
                if (isShowIcon) {
                  dottedLineShowed = false;
                }
                if (
                  series.owner.userFirstName === userData.user.userFirstName &&
                  series.owner.userLastName === userData.user.userLastName
                ) {
                  isShowIcon = true;
                }
                return (
                  <>
                    {isShowIcon && dottedLineShowed && (
                      <DottedBorder>
                        <DottedBorderText>
                          <Body6 color="eerieBlack">{`${series.owner.userLastName.charAt(0).toUpperCase() + series.owner.userLastName.slice(1)}, ${series.owner.userFirstName.charAt(0).toUpperCase() + series.owner.userFirstName.slice(1)} `}</Body6>
                        </DottedBorderText>
                      </DottedBorder>
                    )}
                    <ReplayCardContainer>
                      {isShowIcon && (
                        <ArrowIconContainer level={series.level}>
                          <ReplyIcon width={26} height={150} />
                        </ArrowIconContainer>
                      )}
                      <CardContainer
                        onClick={() => {
                          if (
                            series.assignedId === parseInt(userData.user.id) ||
                            series.ownerId === parseInt(userData.user.id)
                          ) {
                            handleCard(series);
                          }
                        }}
                        isWhite={isWhite}
                        statusCard={getStatusCardClass(series)}
                      >
                        <MessageMainContainer>
                          <UserAvatar
                            userData={series}
                            isShowIcon={isShowIcon}
                          />
                          <CardInfo>
                            <Body6 color="eerieBlack">
                              {series.assigned
                                ? !isShowIcon
                                  ? `${series.owner.userLastName.charAt(0).toUpperCase() + series.owner.userLastName.slice(1)}, ${series.owner.userFirstName.charAt(0).toUpperCase() + series.owner.userFirstName.slice(1)}`
                                  : `${series.assigned.userLastName.charAt(0).toUpperCase() + series.assigned.userLastName.slice(1)}, ${series.assigned.userFirstName.charAt(0).toUpperCase() + series.assigned.userFirstName.slice(1)}`
                                : 'Multiple'}
                            </Body6>
                            <Body6 color="battleShipGray">
                              Received:{' '}
                              {moment(series.insertDate).format('DD MMMM YYYY')}
                            </Body6>
                            <CardMessageTitle>
                              <Headline6 color="battleShipGray">
                                Message Title:{' '}
                              </Headline6>
                              <Body6 color="battleShipGray">
                                {series.messageTitle}
                              </Body6>
                            </CardMessageTitle>
                          </CardInfo>
                        </MessageMainContainer>
                        <hr />
                        <MessageSenderContainer>
                          <div>
                            <Body6 color="eerieBlack">
                              Sent by:{' '}
                              {series.ownerId === parseInt(userData.user.id)
                                ? 'Me'
                                : `${series.owner.userLastName.charAt(0).toUpperCase() + series.owner.userLastName.slice(1)}, ${series.owner.userFirstName.charAt(0).toUpperCase() + series.owner.userFirstName.slice(1)}`}
                            </Body6>
                          </div>
                          {!isShowIcon && (
                            <div>
                              <Body6 color="eerieBlack">
                                To:{' '}
                                {series.assignedId
                                  ? series.assignedId ===
                                    parseInt(userData.user.id)
                                    ? 'Me'
                                    : `${series.assigned.userLastName.charAt(0).toUpperCase() + series.assigned.userLastName.slice(1)}, ${series.assigned.userFirstName.charAt(0).toUpperCase() + series.assigned.userFirstName.slice(1)}`
                                  : 'Multiple'}
                              </Body6>
                            </div>
                          )}
                        </MessageSenderContainer>
                      </CardContainer>
                    </ReplayCardContainer>
                  </>
                );
              })}
          </div>
          {seriesData[seriesData.length - 1].assignedId ===
            parseInt(userData.user.id) && (
            <DottedBorder>
              <DottedBorderText>
                <Body6 color="eerieBlack">{`${seriesData[seriesData.length - 1].assigned.userLastName.charAt(0).toUpperCase() + seriesData[seriesData.length - 1].assigned.userLastName.slice(1)}, ${seriesData[seriesData.length - 1].assigned.userFirstName.charAt(0).toUpperCase() + seriesData[seriesData.length - 1].assigned.userFirstName.slice(1)}`}</Body6>
              </DottedBorderText>
            </DottedBorder>
          )}
          {FifthLevel &&
            seriesData &&
            (!seriesData.find(
              (series) => series.ownerId === userData.user.id
            ) ||
              !!seriesData.find((series) => series.ownerId === userData.user.id)
                .parentId) && (
              <ButtonContainer>
                <ButtonLarge
                  title="Link Action Plan"
                  onClick={() => {
                    handleCreateLinkedActionPlan();
                  }}
                  disabled={isViewer}
                />
              </ButtonContainer>
            )}
        </ContentArea>
      )}
    </>
  );
};

export default ActionPlansSeries;
